import { html } from "lit";
import { customElement, property } from "lit/decorators.js";
import { IconBadge } from "../icon-badge/icon-badge";
import { statusBadgeStyles } from "./status-badge.css";

@customElement("status-badge")
export class StatusBadge extends IconBadge {
  static override styles = [...IconBadge.styles, statusBadgeStyles];

  @property({ type: String })
  variant: "default" | "live" | "ended" | "cancelled" | "scheduled" | "price" | "access" | "event" = "default";

  @property({ type: Boolean })
  pulse = false;

  override render() {
    if (this.primaryColor) {
      this.style.setProperty("--badge-bg", this.primaryColor);
    }
    if (this.secondaryColor) {
      this.style.setProperty("--badge-color", this.secondaryColor);
    }

    return html`
      <div class="badge ${this.variant} ${this.size} ${this.pulse ? "pulse" : ""} ${this.glass ? "glass" : ""}">
        <slot name="icon"></slot>
        <span class="badge-text"><slot></slot></span>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "status-badge": StatusBadge;
  }
}
